import { useScrollIntoView } from 'modules/authentication';
import React, { InputHTMLAttributes, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { FieldWrapper } from 'shared/components';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  sendName: (name: string) => void;
  inputSelector?: string;
}

export const ClientNameInput: React.FC<Props> = ({
  autoFocus,
  sendName,
  inputSelector,
}) => {
  const { formatMessage } = useIntl();
  const { handleFocus } = useScrollIntoView();

  const {
    formState: { errors },
    register,
    getValues,
  } = useFormContext<Client>();

  function handleEmptyString(value: string) {
    return (
      !!value.trim() || formatMessage({ id: 'inputs.client-name.required' })
    );
  }

  useEffect(() => {
    sendName(getValues('name'));
  }, []);

  return (
    <FieldWrapper
      name="name"
      errors={errors}
      labelId="inputs.client-name.label"
      isRequired
    >
      <input
        type="text"
        autoComplete="off"
        autoFocus={autoFocus}
        className={`input input__med input__box ${
          errors.name ? 'input__box__error' : ''
        }`}
        placeholder={formatMessage({ id: 'inputs.client-name.placeholder' })}
        data-cy={inputSelector}
        onFocus={handleFocus}
        {...register('name', {
          required: formatMessage({ id: 'inputs.client-name.required' }),
          maxLength: {
            value: 200,
            message: formatMessage({
              id: 'inputs.client-name.max-length',
            }),
          },
          validate: {
            emptyString: (value) => handleEmptyString(value),
          },
        })}
      />
    </FieldWrapper>
  );
};
